import { createSlice } from "@reduxjs/toolkit";
import { addToCart } from "../thunk/addToCart";
import { fetchCart } from "../thunk/fetchCart";


const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        isLoading: false,
        data: [],
        buyNow: [],
        error: null
    },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchCart.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCart.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchCart.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error;
        });
        builder.addCase(addToCart.fulfilled, (state, action) => {
            if (action.payload) {
                let cart = state.data.find((item) => item.cartId === action.payload.cartId);
                if (cart && action.payload.quantity < 1) {
                    state.data = state.data.filter((item => item.cartId !== action.payload.cartId))
                }
                else if (cart) {
                    cart.quantity = action.payload.quantity;
                }
                else {
                    state.data.push(action.payload);
                }
            }
        });
        builder.addCase("user/logout", (state, action) => {
            state.data = [];
        });
        builder.addCase("empty/cart", (state, action) => {
            state.data = [];
        });
    }
});

export const cartReducer = cartSlice.reducer;
